// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import useDelayedPropVariation from '../../../hooks/useDelayedPropVariation';
import KLKnifeCounterContainer from '../containers/KLKnifeCounterContainer';
import KLOrientationPaginationContainer from '../containers/KLOrientationPaginationContainer';
import KLOrientationStepListContainer from '../containers/KLOrientationStepListContainer';
import KLRulesButtonContainer from '../containers/KLRulesButtonContainer';
import { KLRounds } from '../types/round';

import KLViewWrapper from './common/KLViewWrapper';

const StyleReceiver = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const StyledPaginationContainer = styled(KLOrientationPaginationContainer)`
  margin-top: 0.4em;
  margin-left: -0.2em;
  font-size: 0.9em;
`;

const roundId = KLRounds.ORIENTATION;

const RoundInfosAndRulesRow = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;
`;

type KLRound3Props = {
  className?: string;
  children?: React.ReactNode;
  isLocked: boolean;
};

const KLRound3 = ({ className, isLocked = false, children }: KLRound3Props) => {
  const [delayedIsLocked, prevDelayedIsLocked] = useDelayedPropVariation(isLocked);

  return (
    <KLViewWrapper
      className={className}
      viewType={roundId}
      isLocked={delayedIsLocked}
      prevIsLocked={prevDelayedIsLocked}
    >
      <StyleReceiver>
        <RoundInfosAndRulesRow>
          <KLKnifeCounterContainer />
          <KLRulesButtonContainer roundId={roundId} />
        </RoundInfosAndRulesRow>
        <StyledPaginationContainer />
        <KLOrientationStepListContainer />
        {children}
      </StyleReceiver>
    </KLViewWrapper>
  );
};

export default KLRound3;
